<div class="modal fade" tabindex="-1" role="dialog" id="relatorio-veiculo-detalhado-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Definir filtros</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="container striped-rows">
        <div class="row ptb5">
          <div class="col col-4">
            Mercado
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="text" placeholder="Selecione o Mercado..."
              [(ngModel)]="Mercado">
              <option value="">Selecione o Mercado...</option>
              <option *ngFor="let item of mercado" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div class="col col-4">
            Grupo econômico
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="text" placeholder="Selecione o grupo econômico..."
              (change)="selecionaDealer()" [(ngModel)]="GrupoEconomico">
              <option value="">Selecione o Grupo Econômico...</option>
              <option *ngFor="let item of gruposEconomicos" [value]="item.id"> {{item.descricao}} </option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div class="col col-4">
            Região
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="number" placeholder="Selecione a Região..."
              [(disabled)]="habRegiao" [(ngModel)]="Regiao">
              <option value="">Selecione a Região...</option>
              <option *ngFor="let item of regioes" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div class="col col-4">
            Dealer
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="number" [value]="desabilitaGrupoEconomico()"
              [(ngModel)]="Dealer">
              <option value="">Selecione o Dealer...</option>
              <option *ngFor="let item of dealers" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            Mês Inicial
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="text" placeholder="Selecione o mês inicial..."
              [(ngModel)]="filtros.mes_inicial" [(ngModel)]="mes_inicial">
              <option translate value=1>Janeiro</option>
              <option translate value=2>Fevereiro</option>
              <option translate value=3>Março</option>
              <option translate value=4>Abril</option>
              <option translate value=5>Maio</option>
              <option translate value=6>Junho</option>
              <option translate value=7>Julho</option>
              <option translate value=8>Agosto</option>
              <option translate value=9>Setembro</option>
              <option translate value=10>Outubro</option>
              <option translate value=11>Novembro</option>
              <option translate value=12>Dezembro</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            Mês Final
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="text" placeholder="Selecione o mês final..."
              [(ngModel)]="filtros.mes_final" [(ngModel)]="mes_final">
              <option translate value=1>Janeiro</option>
              <option translate value=2>Fevereiro</option>
              <option translate value=3>Março</option>
              <option translate value=4>Abril</option>
              <option translate value=5>Maio</option>
              <option translate value=6>Junho</option>
              <option translate value=7>Julho</option>
              <option translate value=8>Agosto</option>
              <option translate value=9>Setembro</option>
              <option translate value=10>Outubro</option>
              <option translate value=11>Novembro</option>
              <option translate value=12>Dezembro</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            Ano
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="text" placeholder="Selecione o ano..."
              [(ngModel)]="filtros.ano" [(ngModel)]="ano">
              <option *ngFor="let ano of anoDropDown" value={{ano.value}}>{{ano.value}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="limparFiltro()">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>




<!-- || limparDataInicial(dataInicialView) || limparDataFinal(dataFinalView) -->